export const COMPONENT_NAME = 'SharedMultiCardContent';